import React from "react";
import { string, number } from "prop-types";

import "./iframe.m.css";

const IframeWidget = ({ widgetUrl, widgetHeight, widgetStyles = "" }) => {
  return (
    <iframe
      title="Widget "
      src={widgetUrl}
      style={{ "--widget-height": widgetHeight ? widgetHeight + "px" : undefined }}
      styleName={`${widgetStyles} iframe`}
      className="widget-iframe"
    />
  );
};

IframeWidget.propTypes = {
  widgetUrl: string,
  widgetHeight: number,
  widgetStyles: string,
};

export default IframeWidget;
